import { AxiosResponse } from 'axios';
import ApiService from './api.service';
import { BrandEndpoint, BudtenderEndpoint } from './api.endpoints';
import { BudtenderUserWrite, UserLogin } from '../types';

class BudtenderService extends ApiService {
  async createBudtender(payload: BudtenderUserWrite): Promise<AxiosResponse | undefined> {
    const response = await this.post(BudtenderEndpoint.REGISTER, payload);
    return response;
  }

  async login(payload: UserLogin): Promise<AxiosResponse | undefined> {
    const response = await this.post(BudtenderEndpoint.LOGIN, payload);
    return response;
  }

  async fetchBudtender(): Promise<AxiosResponse | undefined> {
    const response = await this.get(BudtenderEndpoint.FETCH);
    return response;
  }

  async activateBudtender(payload): Promise<AxiosResponse | undefined> {
    const response = await this.post(BudtenderEndpoint.ACTIVATE, payload);
    return response;
  }

  async inviteBudtender(payload): Promise<AxiosResponse | undefined> {
    const response = await this.post(BudtenderEndpoint.INVITE, payload);
    return response;
  }

  async addBudtenderToMeeting(payload: any): Promise<AxiosResponse | undefined> {
    const response = await this.post(BrandEndpoint.ADD_BUDTENDER_TO_MEETING, payload);
    return response;
  }

  async initiatePasswordReset(payload: any): Promise<AxiosResponse | undefined> {
    const response = await this.post(BudtenderEndpoint.INITIATE_PASSWORD_RESET, payload);
    return response;
  }

  async confirmPasswordReset(payload: any): Promise<AxiosResponse | undefined> {
    const response = await this.post(BudtenderEndpoint.CONFIRM_PASSWORD_RESET, payload);
    return response;
  }
}

export default BudtenderService;
